// src/constants/postStyleThemes.js

export const POST_STYLE_THEME_KEYS = [
  'normal',
  'pi_purple',
  'gold_soft',
  'dark_premium',
];

export const POST_STYLE_THEMES = [
  {
    key: 'normal',
    label: 'Normal',
    priceLabel: 'Free',
    description: 'Classic clean post',
    paid: false,
    previewClass: 'post-style-preview-normal',

    // Normal follows the app theme, so these mostly act as fallbacks.
    textColor: 'var(--text)',
    mutedTextColor: 'var(--muted)',
    placeholderColor: 'var(--muted)',
    iconFilter: 'none',
  },
  {
    key: 'pi_purple',
    label: 'Pi Purple',
    priceLabel: '0.5 Pi',
    description: 'Soft Pi-powered purple theme',
    paid: true,
    previewClass: 'post-style-preview-pi-purple',

    // Purple is dark/rich, so white text is safest.
    textColor: '#ffffff',
    mutedTextColor: 'rgba(255, 255, 255, 0.78)',
    placeholderColor: 'rgba(255, 255, 255, 0.72)',
    iconFilter: 'brightness(0) invert(1)',
  },
  {
    key: 'gold_soft',
    label: 'Gold Soft',
    priceLabel: '1 Pi',
    description: 'Premium gold highlight',
    paid: true,
    previewClass: 'post-style-preview-gold-soft',

    // Gold is light, so dark warm text is more readable than white.
    textColor: '#2b2112',
    mutedTextColor: 'rgba(43, 33, 18, 0.70)',
    placeholderColor: 'rgba(43, 33, 18, 0.58)',
    iconFilter: 'none',
  },
  {
    key: 'dark_premium',
    label: 'Dark Premium',
    priceLabel: '1 Pi',
    description: 'Bold dark premium look',
    paid: true,
    previewClass: 'post-style-preview-dark-premium',

    // Dark Premium must always stay white, even in light mode.
    textColor: '#ffffff',
    mutedTextColor: 'rgba(255, 255, 255, 0.76)',
    placeholderColor: 'rgba(255, 255, 255, 0.65)',
    iconFilter: 'brightness(0) invert(1)',
  },
];

export const isValidPostStyleTheme = (key) => {
  return POST_STYLE_THEME_KEYS.includes(key);
};

export const getPostStyleTheme = (key) => {
  const safeKey = isValidPostStyleTheme(key) ? key : 'normal';

  return (
    POST_STYLE_THEMES.find((theme) => theme.key === safeKey) ||
    POST_STYLE_THEMES[0]
  );
};

export const isPaidPostStyleTheme = (key) => {
  return getPostStyleTheme(key).paid === true;
};

export const getPostStyleCssVars = (key) => {
  const theme = getPostStyleTheme(key);

  return {
    '--post-style-text': theme.textColor,
    '--post-style-muted': theme.mutedTextColor,
    '--post-style-placeholder': theme.placeholderColor,
    '--post-style-icon-filter': theme.iconFilter,
  };
};
